module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-infinite-container HeaderTabs"
  }, [_c('mu-tabs', {
    staticClass: "tabs",
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "all",
      "title": "全部"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "good",
      "title": "精华"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "weex",
      "title": "weex"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "share",
      "title": "分享"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "ask",
      "title": "问答"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "job",
      "title": "招聘"
    }
  })], 1), _vm._v(" "), (_vm.inloading) ? _c('div', {
    staticClass: "inloading"
  }, [_vm._v("\n    Loading...\n  ")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.items), function(item, index) {
    return _c('div', [_c('div', {
      staticClass: "list"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/vue-home/dist/people',
          query: {
            user: item.author.loginname
          }
        },
        "src": item.author.avatar_url,
        "tag": "img",
        "alt": "user"
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "content",
      attrs: {
        "to": {
          path: '/vue-home/dist/content',
          query: {
            id: item.id
          }
        },
        "tag": "div"
      }
    }, [_c('div', {
      staticClass: "list-title"
    }, [(item.top) ? _c('span', [_vm._v("置顶")]) : (item.good) ? _c('span', [_vm._v("精华")]) : (item.tab === 'share') ? _c('span', {
      style: (_vm.styleObj)
    }, [_vm._v("分享")]) : (item.tab === 'ask') ? _c('span', {
      style: (_vm.styleObj)
    }, [_vm._v("问答")]) : (item.tab === 'job') ? _c('span', {
      style: (_vm.styleObj)
    }, [_vm._v("招聘")]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "timer"
    }, [_c('span', [_c('mu-icon', {
      attrs: {
        "value": "chat",
        "size": 14
      }
    }), _vm._v(_vm._s(item.reply_count) + "   "), _c('mu-icon', {
      attrs: {
        "value": "visibility",
        "size": 14
      }
    }), _vm._v(_vm._s(item.visit_count))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(item.last_reply_at)))])])])], 1)])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nomore),
      expression: "nomore"
    }],
    staticClass: "nomore"
  }, [_vm._v("内容到底啦")])], 2), _vm._v(" "), (!_vm.items.length) ? _c('div', [_c('strong', [_vm._v("暂无话题")])]) : _vm._e(), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading
    },
    on: {
      "load": _vm.loadMore
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5e207e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderTabs.vue
// module id = 136
// module chunks = 1